import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  setConfirmationModalState, appNotify, loadPostAcqTasks, assignPostAcqTasksTo, unassignPostAcqTasks
} from 'store/actions';
import { ButtonDropdown } from 'components/layout';
import { GetPostAcqContextMenu } from 'api/shared/contextMenu';
import { ImgWithRetry } from 'components/layout';
import { TaskStatusChip } from 'components/underwrite/postAcquisition';

const HeaderImage = ({ classes, user, selectedOpportunity, selectedOpportunityImages, setConfirmationModalState,
  loadPostAcqTasks, appNotify, viewTaskOnWorkflow, assignPostAcqTasksTo, unassignPostAcqTasks, viewingReadonlyMode }) => {

  const [contextMenuData, setContextMenuData] = useState([]);
  const [contextMenuIsLoading, setContextMenuIsLoading] = useState(false); 

  useEffect(() => {
    setContextMenuData([]);
    setContextMenuIsLoading(false);
  }, [selectedOpportunity]);

  const closeConfirmationModal = () => {
    setConfirmationModalState({ isModalOpen: false });
  }

  const handleLoadTasks = (taskIds) => {
    setConfirmationModalState({
      isModalOpen: true,
      handleConfirmation: () => handleLoadTasksConfirmation(taskIds),
      handleCancellation: closeConfirmationModal,
      titleText: 'Confirm',
      contentText: `Are you sure you want to reload data for the task?`
    });
  }

  const handleLoadTasksConfirmation = (taskIds) => {
    closeConfirmationModal();   // close confirm modal first
    loadPostAcqTasks(taskIds);
  }

  const handleAssign = () => {
    assignPostAcqTasksTo('postAcqTask', [selectedOpportunity.id], user.id, user.id);
  }

  const handleUnassign = () => {
    unassignPostAcqTasks('postAcqTask', [selectedOpportunity.id], user.id);
  }

  function copyToClipboard(string) {
    const focusEl = document.activeElement
    const dummy = document.createElement('textarea');
    focusEl.appendChild(dummy); // When in viewValuationDialog, MUI enforces focus on the dialog, preventing the dummy from selecting if appended to body. Append to element in dialog instead (potentially visible if it runs slow, can either look into hiding or just disableEnforceFocus for dialog)
    dummy.value = string;
    dummy.select();
    document.execCommand('copy');
    focusEl.removeChild(dummy);
  }

  const fetchContextMenuData = async () => {
    setContextMenuIsLoading(true);
    setContextMenuData([]);

    try {
      const contextMenuFetchedData = await GetPostAcqContextMenu([selectedOpportunity.id], 'PostAcquisitionUnderwrite');

      if (contextMenuFetchedData.status == 'fail') {
        var error = new Error();
        error.message = contextMenuFetchedData.error.message;
        throw error;
      }

      let menuItems = contextMenuFetchedData.map(item => {
        let clickHandler = () => console.log(`No click handler found for ${item.action}`);
        let itemName = item.actionDisplayName;
        let disabled = !item.enabled;
        switch (item.action) {
          case 'CopyRow': {
            clickHandler = () => copyToClipboard(selectedOpportunity.id);
            itemName = 'Copy ID to clipboard';
            break;
          }
          case 'LoadTask':
            clickHandler = () => handleLoadTasks([selectedOpportunity.id]);
            disabled = disabled || viewingReadonlyMode;
            break;
          case 'AssignTaskToMe': {
            clickHandler = () => handleAssign();
            itemName = 'Assign task to me';
            break;
          }
          case 'UnassignTaskFromMe': {
            clickHandler = () => handleUnassign();
            itemName = 'Unassign task from me';
            break;
          }
          case 'ViewOnWorkflow': 
            clickHandler = () => viewTaskOnWorkflow(selectedOpportunity.id);
            break;
          default:
            break;
        }
        return {
          text: itemName,
          disabled,
          onItemClick: clickHandler
        }
      });
      setContextMenuData(menuItems);
    } catch (e) {
      appNotify(e.message, 'error');
    }
    setContextMenuIsLoading(false);
  }

  const handleSelect = item => {
    item.onItemClick();
  }

  return (
    <div className={classes.container}>
      {selectedOpportunityImages?.length &&
        <ImgWithRetry alt="main-property" className={classes.headerImage} src={selectedOpportunityImages[0].images[0].imageUrl} retryCount={2}/>
      }
      <div className={classes.overlayContainer}>
        <TaskStatusChip
          task={selectedOpportunity}
        />
        <ButtonDropdown
          title={`ID ${selectedOpportunity.id}`}
          items={contextMenuData}
          isLoading={contextMenuIsLoading}
          openCallback={fetchContextMenuData}
          onSelect={handleSelect}
          size='tiny'
          style={{
            margin: 0,
            color: '#fff',
            background: 'rgba(0, 0, 0, 0.7)',
            '&:hover': {
              background: 'rgba(0, 0, 0, 0.5)'
            }
          }}
        />
      </div>
    </div>
  )
};

const styles = theme => ({
  container: {
    display: 'flex',
    width: '125px',
    position: 'relative'
  },
  headerImage: {
    width: '100%',
    objectFit: 'cover',
  },
  overlayContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: '3px 0'
  }
});

const mapStateToProps = (state, ownProps) => {
  const uwState = ownProps.viewingReadonlyMode ? state.postAcqUWState.underwriteModalState : state.postAcqUWState;
  
  return {
    user: state.appState.user,
    selectedOpportunity: uwState.postAcqUWClientTask,
    selectedOpportunityImages: state.postAcqUWState.selectedOpportunityImages
  }
};

const mapDispatchToProps = {
  setConfirmationModalState,
  appNotify,
  loadPostAcqTasks,
  assignPostAcqTasksTo,
  unassignPostAcqTasks
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(HeaderImage);
